const cachedAxiosOptions = {
  cache: {
    ttl: 1000 * 60 * 60 * 10,
    interpretHeader: false,
    cacheTakeover: false,
  },
}

export { cachedAxiosOptions }
